// ./components/Textarea.ts
import { ComponentStyleConfig } from '@chakra-ui/react';

export const Textarea: ComponentStyleConfig = {
  variants: {
    outline: {
      bg: 'white',
    },
  },
};
